import { render, staticRenderFns } from "./ProductScreen.vue?vue&type=template&id=6fb5617a"
import script from "./ProductScreen.vue?vue&type=script&lang=js"
export * from "./ProductScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports